import _ from '../../utils';

export default class ServiceCache<T> {
  private cache: any = {};

  get(url: string, params: any): T | null {
    if (!this.cache[url]) {
      return null;
    }
    const paramsHash = _.hash(params ?? {});
    if (this.cache[url][paramsHash]) {
      return this.cache[url][paramsHash];
    }
    return null;
  }

  set(url: string, params: any, data: T) {
    const paramsHash = _.hash(params ?? {});
    this.cache[url] = this.cache[url] || {};
    this.cache[url][paramsHash] = data;
  }

  clear() {
    this.cache = {};
  }
}
